import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app';
import './index.css';

// React 19 uses createRoot from react-dom/client
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// TEMPORARILY DISABLED: Service Worker was caching old Stripe code
// Unregister any existing service workers to clear cache
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
      console.log('Service Worker unregistered to clear cache:', registration);
    }
  });
}

// Original service worker code (COMMENTED OUT):
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/service-worker.js')
//       .then(registration => {
//         console.log('Service Worker registered successfully:', registration);
//       })
//       .catch(error => {
//         console.error('Service Worker registration failed:', error);
//       });
//   });
// }